import useSWRMutation from "swr/mutation";
import useHttpClient from "../useHttpClient";
import { Loan } from "../../types";

interface EarlyPaymentWithdrawArgs {
  amount: number;
  currency: "IRT" | "USDT";
  wallet?: string;
  network?: string;
}

interface EarlyPaymentWithdrawResult {
  loan: Loan | null;
  withdrawal: any;
}

const useEarlyPaymentWithdraw = () => {
  const httpClient = useHttpClient();
  return useSWRMutation(
    "early-payment-withdraw",
    async (
      _key: string,
      { arg }: { arg: EarlyPaymentWithdrawArgs }
    ): Promise<EarlyPaymentWithdrawResult> =>
      httpClient.post("/loans/withdraw", arg).then((res) => res.data.data)
  );
};

export default useEarlyPaymentWithdraw;
